import { preLevelHelperReward } from '../../../Config/Helpers';
import { ILevelConfig } from '../../../Config/Levels';
import Core from '../../../Core/Core';
import { HudActions, HudEmitter } from '../../../Managers/Hud/HudEmitter';
import { Popup } from '../../../Managers/Popups';
import { IFBFriend } from '../../../SDK/SDKfb';
import { Collection } from '../../../Tiles/TileSet';
import { buttonIdleAnimation } from '../../Animations/UIAnimations';
import { ButtonColors } from '../../Shared/Buttons/NineSliceButton';
import { TextButton } from '../../Shared/Buttons/TextButton';
import { UIButton } from '../../Shared/Buttons/UIButton';
import { CharacterPopup } from '../CharacterPopup';
import { PlayWithFriendButton } from './PlayWithFriendButton';
import { PrelevelGoalDisplay } from './PrelevelGoalDisplay';

/**
 * Prelevel popup, shown when user taps a node on map screen
 *
 * constructor params..
 * @params width - width of popup
 * @params height - height of popup
 * @params config - object containing data for level, props used here are level id and goal
 * @params boosterlist - array of strings that determine which boosters are shown on prelevel
 * @params boosterCallback - callback used in manager passed to booster select group
 */
export class PreLevelPopup extends CharacterPopup {
    private btns: UIButton[] = [];

    constructor(
        width: number,
        height: number,
        config: ILevelConfig,
        boosterList: string[],
        boosterCallback: (id: string, selected: boolean) => void,
        helperFriend: IFBFriend,
        collection: Collection
    ) {
        super(
            width,
            height,
            config.goal.type === 'toys'
                ? 'character/character-goal'
                : 'character/character-default',
            Core.local.getText('level').split('[x]')[0] + parseInt(config.levelId, 10).toString(10),
            Popup.PRELEVEL
        );
        const { header, bg } = this;

        const hasFriend = helperFriend !== null;

        const goals = new PrelevelGoalDisplay(
            [config.goal],
            width * 0.65,
            height * 0.18,
            collection
        );
        goals.x = width - width * 0.825;
        goals.y = header.y + header.height / 2;

        let last: PIXI.Container = goals;

        const playButton = new TextButton({
            width: width * 0.5,
            height: height * 0.15,
            btnText: Core.local.getText(hasFriend ? 'playAlone' : 'play'),
            color: hasFriend ? ButtonColors.DARK_GREEN : ButtonColors.GREEN,
        });
        this.addChild(header, goals, playButton);

        let animatedButton: UIButton = playButton;
        if (hasFriend) {
            const playWithFriendButton = new PlayWithFriendButton(
                helperFriend,
                preLevelHelperReward,
                width * 0.56,
                height * 0.16
            );
            playWithFriendButton.on(UIButton.events.Trigger, () => {
                HudEmitter.instance.emit(
                    HudActions.ASK_FRIEND,
                    helperFriend,
                    preLevelHelperReward,
                    () => {
                        HudEmitter.instance.emit(HudActions.CLOSE_POPUP, Popup.PRELEVEL, 0, 'play');
                    }
                );
            });
            playWithFriendButton.x = width / 2;
            playWithFriendButton.y = last.y + last.height + playWithFriendButton.height / 1.9;
            last = playWithFriendButton;
            animatedButton = playWithFriendButton;
            this.btns.push(playWithFriendButton);
            this.addChild(playWithFriendButton);
        }
        playButton.x = width / 2;
        playButton.y =
            last.y +
            (hasFriend
                ? last.height / 2 + playButton.height / 2.1
                : last.height + playButton.height / 1.3);

        playButton.on('trigger', () =>
            HudEmitter.instance.emit(HudActions.CLOSE_POPUP, Popup.PRELEVEL, 0, 'play')
        );

        const newHeight = playButton.y + playButton.height / 2 + 50;

        buttonIdleAnimation(animatedButton, 2);
        bg.height = Math.min(newHeight, height);
    }
}
